import { render, staticRenderFns } from "./PollDraftHandler.vue?vue&type=template&id=29c4a5c6&scoped=true"
import script from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollDraftHandler.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PollDraftHandler.vue?vue&type=style&index=0&id=29c4a5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c4a5c6",
  null
  
)

export default component.exports